import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import Styles from "./GnaAdmin.module.css";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import AddAdmin from "../AddAdmin/AddAdmin";
import { getAdmins } from "../../../../Services/GNA/GetData";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CompanyUserSelection from "../CompanyUserSelection/CompanyUserSelection";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAdmins,
  fetchCompany,
} from "../../../../Redux/Slices/gnaAdminSlice";
import {
  adminCompanyAccess,
  handleDisableUser_Admin,
} from "../../../../Services/GNA/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../commons/Toast/ErrorMessage";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";

const GnaAdmin = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const admins = useSelector(
    (state) => state?.gnaAdminSlice?.fetchAdmins?.data
  );
  console.debug("admin", admins);
  const [addModal, setAddModal] = useState(false);

  const [selction, setSelection] = useState(false);
  const [selId, setSelId] = useState({});
  const [selected, setSelected] = useState([]);

  const [editData, setEditData] = useState(null);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmId, setConfirmId] = useState(null);

  useEffect(() => {
    handleFetchAdmins();
  }, []);

  const handleFetchAdmins = async () => {
    dispatch(fetchAdmins());
  };

  const handleCompanySelection = async (data) => {
    const payload = data?.map((item) => ({
      companyId: item, // Copies all original properties from the 'item'
      adminUserId: selId?.userId,
      adminRole: selId?.userType,
    }));
    let res = await adminCompanyAccess(payload);
    if (res?.data?.code === 200) {
      handleFetchAdmins();
      dispatch(fetchCompany());
      setSelection(false);
    } else {
      ErrorMessage(res?.data?.error || "Failed to assign companies to admin");
    }
  };

  const handleUpdateCompanySelection = async (id) => {
    if (selected.includes(id)) {
      setSelected((prev) => prev.filter((item) => item !== id));
    }
  };

  const handleEditClick = (data) => {
    setEditData(data);
    setAddModal(true);
  };

  const handleDeleteUser = async () => {
    let res = await handleDisableUser_Admin(confirmId);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      handleFetchAdmins();
      setConfirmDelete(false);
    } else {
      ErrorMessage(res?.data?.error);
    }
  };

  return (
    <>
      {addModal && (
        <AddAdmin
          open={addModal}
          handleClose={() => {
            setAddModal(false);
            setEditData(null);
          }}
          handleFetchAdmins={handleFetchAdmins}
          editData={editData}
        />
      )}

      {selction && (
        <CompanyUserSelection
          open={selction}
          handleClose={() => {
            setSelection(false);
            setSelected(null);
          }}
          selected={selected}
          type={"Company"}
          handleSubmit={handleCompanySelection}
          handleSelection={handleUpdateCompanySelection}
        />
      )}

      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          handleClose={() => setConfirmDelete(false)}
          data={`Are you sure you want to delete admin?`}
          handleSubmit={handleDeleteUser}
        />
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.adminContainer}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.headingText}`}
          >
            <div className={`headingText ${Styles.finalHead}`}>
              GNA Admin(s)
            </div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.tableMainCont}>
            <div className={`display_flex_row`}>
              <div className={Styles.adminCount}>
                <span>Total Admins : </span>
                <b>{admins?.length}</b>
              </div>
              <div
                className={Styles.addAdminCntainer}
                onClick={() => setAddModal(true)}
              >
                <AddIcon style={{ fontSize: "16px" }} />
                <span>Add Admin</span>
              </div>
            </div>
            <div className={Styles.adminListsContainer}>
              <div className="display_flex_row tableHeading">
                <div style={{ width: "15%" }}>Name</div>
                <div style={{ width: "10%" }}>Username</div>
                <div style={{ width: "10%" }}>Phone</div>
                <div style={{ width: "15%" }}>Email</div>
                <div style={{ width: "15%" }}>Type</div>
                <div style={{ width: "15%" }}>Assigned Company</div>
                <div style={{ width: "10%" }}>Alter</div>
              </div>
              <div className={`scroll_bar_y ${Styles.adminListContainer}`}>
                {admins?.map((ele) => (
                  <div className="display_flex_row tableDetails">
                    <div style={{ width: "15%" }}>{ele?.fullName}</div>
                    <div style={{ width: "10%" }}>{ele?.userName}</div>
                    <div style={{ width: "10%" }}>{ele?.phone}</div>
                    <div style={{ width: "15%" }}>{ele?.email}</div>
                    <div style={{ width: "15%" }}>{ele?.userType}</div>
                    <div style={{ width: "15%" }}>
                      {ele?.assignedCompanies?.length === 0 ? (
                        <PersonAddIcon
                          style={{
                            fontSize: "16px",
                            cursor: "pointer",
                            color: "#f1935c",
                          }}
                          onClick={() => {
                            setSelection(true);
                            setSelId(ele);
                          }}
                        />
                      ) : (
                        <div className="display_flex_row_gap_8">
                          <span>{ele?.assignedCompanies?.length}</span>
                          <VisibilityIcon
                            style={{
                              fontSize: "16px",
                              cursor: "pointer",
                              color: "#f1935c",
                            }}
                            onClick={() => {
                              setSelection(true);
                              setSelId(ele);
                              setSelected(
                                ele?.assignedCompanies?.map(
                                  (item) => item?.companyId
                                )
                              );
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      style={{ width: "10%" }}
                      className="display_flex_row_gap_8"
                    >
                      <BorderColorIcon
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                          color: "#525062",
                        }}
                        onClick={() => handleEditClick(ele)}
                      />
                      <DeleteIcon
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                          color: "red",
                        }}
                        onClick={() => {
                          setConfirmDelete(true);
                          setConfirmId(ele?.userId);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default GnaAdmin;
